const gridLabelStyles = {
    '& label': {
        whiteSpace: 'nowrap',
    },
};

export { gridLabelStyles };
